import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useSurveys from '@helsenorge/framework-utils/additional-page-content/useSurveys';
import { setSurveysCookie } from '@helsenorge/framework-utils/additional-page-content/utils';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import FeedbackModalWrapper from './feedbackmodal-wrapper';
import { useAppSelector } from '../store/hooks';
import UxSignalsWrapper from '../uxsignals-wrapper';
/**
 * Viser undersøkelser som modaler.
 */
const FeedbackModalContainer = () => {
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    const { data: unansweredSurveys, isLoading } = useSurveys({ languageCode: language, component: 'modal' });
    const surveys = unansweredSurveys?.filter(survey => survey._type === 'survey');
    const uxSignalSurveys = unansweredSurveys?.filter(survey => survey._type === 'uxsignals');
    const handleClose = (id) => {
        setSurveysCookie(id);
    };
    if (isLoading) {
        return null;
    }
    // Ikke vis invitasjonen under automatiserte tester (f.eks. Playwright)
    if (navigator.webdriver) {
        return null;
    }
    return (_jsxs("div", { "data-testid": "feedback-modal-container", children: [surveys?.map(survey => (_jsx(FeedbackModalWrapper, { survey: survey, onClose: handleClose }, survey.id))), uxSignalSurveys?.map(survey => (_jsx(UxSignalsWrapper, { survey: survey }, survey.id)))] }));
};
export default FeedbackModalContainer;
